import type { HTMLAttributes, ReactNode } from "react";

export interface NoticeProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  tone?: "info" | "success" | "warning" | "danger";
  title?: ReactNode;
}

/**
 * Итог действия под полем скана, а не диалогом и не тостом (chmk_base,
 * shelf.js, критика 27 октября): диалог ждёт клика, и следующий скан
 * дописывается к старому коду, а тост на телефоне закрывает поле. Ошибка
 * читается сразу (role="alert"), остальное вежливо (role="status").
 */
export function Notice({ tone = "info", title, children, className, ...rest }: NoticeProps) {
  return (
    <div
      className={className ? `w-notice ${className}` : "w-notice"}
      data-tone={tone}
      role={tone === "danger" ? "alert" : "status"}
      {...rest}
    >
      {title ? <strong className="w-notice-title">{title}</strong> : null}
      {children ? <div className="w-notice-body">{children}</div> : null}
    </div>
  );
}
